import { render, staticRenderFns } from "./SaveSearchStar.vue?vue&type=template&id=43c649e7"
import script from "./SaveSearchStar.vue?vue&type=script&lang=js"
export * from "./SaveSearchStar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports